export default {
  brand: 'USFansLink',
  navSpreadsheet: 'Spreadsheet',
  navGuides: 'Guides',
  navReviews: 'Reviews',
  navShipping: 'Shipping',
  navSafety: 'Safety',
  navBlog: 'Blog',
  browseLabel: 'Browse Categories',
  categoryTitle: 'Shop by Category',
  categorySubtitle: 'Jump straight to the section you need on the main website.',
  visitMain: 'Visit Main Website',
  buyNow: 'Buy It Now',
  usfansSpreadsheet: 'USFans Spreadsheet',
  language: 'Language',
  footerTagline: 'Your independent resource hub for USFans Spreadsheet guides, product research, QC tips and shipping information.',
  footerResources: 'Resources',
  footerLegal: 'Legal',
  about: 'About',
  editorialPolicy: 'Editorial Policy',
  contact: 'Contact',
  privacyPolicy: 'Privacy Policy',
  terms: 'Terms',
  disclaimer: 'Disclaimer',
  disclaimerText: 'USFansLink.beauty is an independent informational resource and is not affiliated with or endorsed by USFans unless explicitly stated.',
  navHome: 'Home',
  navShoppingGuide: 'Shopping Guide',
  tagResource: 'Resource',
  tagReview: 'Review',
  tagLegit: 'Legit',
  tagShipping: 'Shipping',
  tagWarehouse: 'Warehouse',
  tagQc: 'QC',
  tagCoupon: 'Coupon',
  tagSeller: 'Seller',
  tagSafety: 'Safety',
  copyright: '© 2026 USFansLink.beauty. All rights reserved.',
  notFoundTitle: 'Article Not Found',
  notFoundText: 'The article you are looking for does not exist or may have been moved.',
};